import React from 'react';
import ReactDOM from 'react-dom/client';
import { initSentry } from './observability';
import { initPostHog, initWebVitals } from './analytics';

initSentry();
initPostHog();
initWebVitals();

import '@fontsource/manrope/400.css';
import '@fontsource/manrope/500.css';
import '@fontsource/manrope/700.css';
import '@fontsource/manrope/800.css';
import '@fontsource/fraunces/400-italic.css';
import './i18n';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Remove splash screen after React mounts
const splash = document.getElementById('splash');
if (splash) {
  // Reset body background before fade
  document.body.style.background = '';
  document.documentElement.style.background = '';
  splash.style.opacity = '0';
  setTimeout(() => splash.remove(), 400);
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('[SW] Registration failed:', err);
    });
  });
}

